
import { getUTCOffset } from "@/utils";
import { defineComponent } from "vue";
import { mapState, mapGetters, mapActions } from "vuex";
import { Month, WeekDay } from "@/common/constants";

export default defineComponent({
  name: "Week",
  data() {
    return {
      utc_offset: getUTCOffset(),
      Month,
      WeekDay,
    };
  },
  computed: {
    ...mapGetters({
      week_days: "calendar/getWeekDays",
      week_agenda: "agenda/getWeek",
    }),
    ...mapState("calendar", ["current_date", "period", "now"]),
  },
  methods: {
    posFullDetail() {
      const mgt = document.querySelector("main.grid-item") as Element;
      const consultas_full_detail = document.querySelectorAll(
        ".consulta-full-detail"
      );

      const max_bottom =
        mgt.getBoundingClientRect().height + mgt.getBoundingClientRect().top;
      const max_right =
        mgt.getBoundingClientRect().width + mgt.getBoundingClientRect().left;
      const max_top = mgt.getBoundingClientRect().top;

      let fd_height: number =
        consultas_full_detail[0] &&
        consultas_full_detail[0].getBoundingClientRect().height;
      let fd_width: number =
        consultas_full_detail[0] &&
        consultas_full_detail[0].getBoundingClientRect().width;

      let e_top, e_right, test_top, test_bottom, test_right;
      for (const e of consultas_full_detail) {
        e_top = e.getBoundingClientRect().top;
        e_right = e.getBoundingClientRect().left;

        test_bottom = e_top + fd_height > max_bottom;
        test_top = e_top < max_top;
        test_right = e_right + fd_width > max_right;

        if (
          (test_bottom && test_right) ||
          (test_bottom && e.classList.contains("consulta-in-right-top"))
        ) {
          e.classList.add("consulta-in-right-bottom");
          e.classList.remove("consulta-in-right-top");
        } else if (
          (test_right && test_top) ||
          (test_top && e.classList.contains("consulta-in-right-bottom"))
        ) {
          e.classList.add("consulta-in-right-top");
          e.classList.remove("consulta-in-right-bottom");
        } else if (test_bottom) {
          e.classList.add("consulta-in-bottom");
          e.classList.remove("consulta-in-top");
        } else if (test_top) {
          e.classList.add("consulta-in-top");
          e.classList.remove("consulta-in-right-bottom");
        } else if (test_right) {
          e.classList.add("consulta-in-right");
        }
      }
    },
    ...mapActions({
      initRecord: "record/initRecord",
      initUpdateRecord: "record/initUpdateRecord",
    }),
  },
});
